import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {type FC, useState} from 'react';
import {useTranslation} from 'react-i18next';
import DialogPanel from '@/components/common/DialogPanel';
import InputNumber from '@/components/common/forms/InputNumber';
import Label from '@/components/common/Label';

//TYPES
type Props = {
  realWeight?: number;
  onClose: () => void;
  onCutChange: (weight?: number) => void;
};

const EnterWeightDialog: FC<Props> = ({realWeight, onClose, onCutChange}) => {
  const {t} = useTranslation();

  const [weight, setWeight] = useState<number | undefined>(realWeight);

  const handleWeight = (realWeight: number) => setWeight(realWeight);
  const handleCut = () => {
    onCutChange(weight);
    onClose();
    setWeight(undefined);
  };

  return (
    <DialogPanel isOpen={true} label={t('forestMass.enterWeight')} onClose={onClose}>
      <Stack direction="column" sx={{maxWidth: '350px', p: 1}}>
        <Typography gutterBottom>{t('forestMass.enterWeightDetail')}</Typography>
        <Label value={t('cuttingConfirmation.realWeight')} required={false}>
          <InputNumber value={weight} onChange={handleWeight} />
        </Label>

        <Stack direction="row" sx={{justifyContent: 'space-between', mt: 4}}>
          <Button onClick={onClose}>{t('cancel')}</Button>
          <Button variant="contained" onClick={handleCut}>
            {t('accept')}
          </Button>
        </Stack>
      </Stack>
    </DialogPanel>
  );
};
export default EnterWeightDialog;
